import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_PhoneNumberInputGroup = _resolveComponent("PhoneNumberInputGroup")!
  const _component_ValidationField = _resolveComponent("ValidationField")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      電話番号の変更\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PhoneNumberInputGroup, {
        value: _ctx.oldPhoneNumber,
        label: "現在の電話番号",
        placeholder: "の携帯電話番号",
        class: "mb-3",
        disabled: ""
      }, null, 8, ["value"]),
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, {
        tag: "div",
        class: "w-100"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, {
            onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.nextStep)), ["stop","prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationField, {
                label: "電話番号",
                rules: "required|numeric|length:11|phonenumber_to_receive_sms",
                name: "newPhoneNumber"
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_PhoneNumberInputGroup, {
                    modelValue: _ctx.newPhoneNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPhoneNumber) = $event)),
                    label: "変更後の電話番号",
                    placeholder: "変更後の電話番号",
                    class: "mb-3",
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "validation-state"])
                ]),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(_component_AppButton, {
                block: "",
                onClick: ($event: any) => (handleSubmit(_ctx.nextStep))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            次へ\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"])
            ], undefined, true),
            _: 2
          }, 1032, ["onSubmit"])
        ]),
        _: 1
      })
    ])
  ]))
}